import styled, { CreateStyled } from '@emotion/styled';
import { ThemeProps } from 'lucid-components-react/dist/theme/theme';

export default styled as CreateStyled<ThemeProps['theme']>;
